/**
 * PaySafeGo import-mapping template fields — one list per feed type.
 * Shown in Group Configuration → Import Mapping template editor.
 */

export const IMPORT_MAPPING_FIELDS = {
  meter: [
    'EgmPK', 'SnapshotTime', 'GamingDate', 'MeterReadTime', 'Turnover', 'CreditWin', 'CancelCredit',
    'Stroke', 'Credit', 'CashlessIn', 'CashlessOut', 'CashIn', 'CashDrop', 'CoinOut',
    'Bill5', 'Bill10', 'Bill20', 'Bill50', 'Bill100', 'TicketsIn', 'Venue',
  ],
  sessions: [
    'SessionPK', 'MemberID', 'EgmName', 'EgmPK', 'GameVariationPK', 'GamingDate', 'StartTime', 'EndTime',
    'Turnover', 'Stroke', 'CreditWin', 'ExternalWin', 'Rewards', 'PointsToCr', 'Venue',
    'venue_code', 'site_code', 'venue_total', 'MeterValid',
  ],
  egm: [
    'EgmPK', 'EgmId', 'HouseNumber', 'EgmName', 'GameName', 'SerialNumber', 'GMID', 'Manufacturer',
    'MachineClass', 'Denom', 'MaxBet', 'RTP', 'Zone', 'Area', 'Status', 'InstallDate', 'DeinstallDate',
    'ChangeDate', 'Active', 'Venue', 'VenueId', 'VenueCode',
  ],
  patron: [
    'PatronID', 'MemberID', 'MembershipNumber', 'FullName', 'FirstName', 'LastName', 'DateOfBirth',
    'Email', 'Phone', 'Gender', 'Country', 'State', 'Postcode', 'Suburb', 'Address1', 'Address2',
    'JoinDate', 'ExpiryDate', 'MembershipStatus', 'MembershipTier', 'CardNumber', 'PointsBalance',
    'ProfileType', 'VenueCode', 'TestFlag', 'RecordStatus',
  ],
  slot_analysis: [
    'GamingDate', 'EgmId', 'Turnover', 'TurnoverAdj', 'Stroke', 'GamesPlayed', 'NetCreditWin', 'CashIn',
    'TotalProcessed', 'CashOut', 'MachineRetained', 'SessionCount', 'RatedTurnover', 'JackpotWin',
    'JackpotTheoretical', 'JackpotVariance', 'CancelCreditVouchers', 'ProgressiveVouchers', 'HandpayCount',
    'FillVouchers', 'ShortPayVouchers', 'ClearanceTickets', 'ValidFlag', 'Venue',
  ],
  visitor: [
    'EntryID', 'VisitID', 'FirstName', 'LastName', 'EntryDateTime', 'EntryDate', 'DateOfBirth',
    'Email', 'MobilePhone', 'Phone', 'RXProfileID', 'VisitorEntryType', 'MemberID',
  ],
  tito: [
    'EventTime', 'TicketID', 'CreatedAt', 'Amount', 'RedeemedAt',
  ],
}

export const IMPORT_MAPPING_FIELD_HINTS = {
  meter: {
    GamingDate: 'Trading day — map when vendor supplies it (otherwise stamped on ingest)',
    MeterReadTime: 'Clock time of meter read when separate from snapshot',
    CashlessIn: 'Cashless in meter — map when vendor supplies it',
    CashlessOut: 'Cashless out meter — map when vendor supplies it',
    CoinOut: 'Coin out meter',
    Bill5: 'Bill acceptor $5 count',
    Bill10: 'Bill acceptor $10 count',
    Bill20: 'Bill acceptor $20 count',
    Bill50: 'Bill acceptor $50 count',
    Bill100: 'Bill acceptor $100 count',
  },
  egm: {
    GMID: 'Vendor game-machine id (rules GMID) → egm_registry.gmid',
    ChangeDate: 'Vendor last-change date → egm_registry.vendor_change_date',
    MachineClass: 'EGM type / device class (EgmType alias on import)',
    Denom: 'Coin/credit denomination (CoinDenom alias on import)',
    DeinstallDate: 'Decommission date (DelisensedDate alias on import)',
    SerialNumber: 'Cabinet serial (SerialNo alias on import)',
  },
  patron: {
    MemberID: 'Alternate member id when different from PatronID',
    ProfileType: 'MEMBER or VISITOR (defaults to MEMBER)',
  },
  visitor: {
    EntryID: 'Visitor system entry id (required)',
    VisitID: 'Alias for EntryID on some VMS extracts',
    RXProfileID: 'RXConnect profile id (stored in vms_data)',
  },
  tito: {
    EventTime: 'When this print or redeem happened',
    TicketID: 'Voucher id',
    CreatedAt: 'Machine that printed the voucher',
    Amount: 'Dollars on the voucher',
    RedeemedAt: 'Machine or terminal that took it. Blank or NULL means still open',
  },
}

export function importMappingFieldsForType(mappingType) {
  return IMPORT_MAPPING_FIELDS[mappingType] || IMPORT_MAPPING_FIELDS.egm
}

export function importMappingFieldHint(mappingType, field) {
  return IMPORT_MAPPING_FIELD_HINTS[mappingType]?.[field] || null
}
